import {
  Activity,
  Bell,
  Building2,
  CalendarCheck,
  ClipboardCheck,
  CreditCard,
  Dumbbell,
  Grid2x2,
  History,
  Inbox,
  Layers,
  LayoutDashboard,
  Lightbulb,
  Megaphone,
  MessageSquare,
  ReceiptIndianRupee,
  Salad,
  ScanSearch,
  ScrollText,
  Sparkles,
  Terminal,
  TicketPercent,
  ToggleRight,
  Users,
  type LucideIcon,
} from 'lucide-react';

import type { ScreenId } from './navigation';

/**
 * One glyph per screen.
 *
 * Kept out of `navigation.ts` so that file stays a plain data module: it is
 * typed `as const satisfies`, and mixing component references into it would
 * widen the literal `path` types the router depends on.
 */
export const NAV_ICONS: Readonly<Record<ScreenId, LucideIcon>> = {
  overview: LayoutDashboard,
  users: Users,
  gyms: Building2,
  foods: Salad,
  foodrequests: Inbox,
  catalogchanges: History,
  feedback: MessageSquare,
  exercises: Dumbbell,
  exerciserequests: ScanSearch,
  gymcatalog: ClipboardCheck,
  planops: CalendarCheck,
  patterns: Grid2x2,
  aiops: Sparkles,
  aispend: ReceiptIndianRupee,
  jobs: Layers,
  notifications: Bell,
  rhythm: Activity,
  broadcasts: Megaphone,
  waittips: Lightbulb,
  billing: CreditCard,
  promotions: TicketPercent,
  switches: ToggleRight,
  console: Terminal,
  activity: ScrollText,
};
